import { render, staticRenderFns } from "./ManageVisitsEntities.vue?vue&type=template&id=3caa1e4a&"
import script from "./ManageVisitsEntities.vue?vue&type=script&lang=js&"
export * from "./ManageVisitsEntities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3caa1e4a', component.options)
    } else {
      api.reload('3caa1e4a', component.options)
    }
    module.hot.accept("./ManageVisitsEntities.vue?vue&type=template&id=3caa1e4a&", function () {
      api.rerender('3caa1e4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/CommercialManagement/ManageVisitsEntities.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/CommercialManagement/ManageVisitsEntities.vue
// module id = mg0B
// module chunks = 0